function src_default(Alpine) {
    Alpine.directive("validate", (el, {value, expression}, {effect, evaluateLater}) => {
        let expressionArray = expression.split("|");
        let lastInputValue = "";
        el.addEventListener("input", () => processInputValue(el));
        el.addEventListener("blur", () => processInputValue(el, false));

        function processInputValue(element, shouldRestoreCursor = true) {
            let input = element.value;
            if (lastInputValue.length - element.value.length === 1) {
                return lastInputValue = element.value;
            }
            let setInput = () => {
                lastInputValue = element.value = formatInput(input);
            };
            if (shouldRestoreCursor) {
                restoreCursorPosition(element, () => {
                    setInput();
                });
            } else {
                setInput();
            }
        }
        function formatInput(input) {
            if (input === "")
                return "";
            if (expressionArray.includes("name"))
                input = name(input);
            return input;
        }
    });
}
function restoreCursorPosition(el, callback) {
    let cursorPosition = el.selectionStart;
    let unformattedValue = el.value;
    callback();
    let beforeLeftOfCursorBeforeFormatting = unformattedValue.slice(0, cursorPosition);
    let newPosition = name(beforeLeftOfCursorBeforeFormatting).length;
    el.setSelectionRange(newPosition, newPosition);
}
function name(input) {
    input = input.toLowerCase().replace(/^[\u00C0-\u1FFF\u2C00-\uD7FF\w]|\s[\u00C0-\u1FFF\u2C00-\uD7FF\w]/g, function(letter) {
        return letter.toUpperCase();
    });

    input = input.replace(/^ +/, '');
    input = input.replace("''", "'");
    return removeChars(input);
}
function removeChars(input) {
    return input.replace(/[0-9\+\=\!\?\"\&\%\$\@\#\^\(\)\:\;\<\>\!\*\{\}\[\]\,\.\/\\\|\_]/g, '')
}

document.addEventListener("alpine:init", () => {
    window.Alpine.plugin(src_default);
});
